import React from "react";

import { setAmplitudeUserProperties, trackAmplitudeEvent } from "../amplitude";
import { annualizedAmount, discountedSalePrice, isFullPriceProduct, perMonthAmount, perWeekAmount, savingsPercentFromAmounts } from "../paddlePrice";
import LoadingOverlay from "./LoadingOverlay";

export default class PaddleCheckout extends React.Component {
  constructor(props) {
    super(props);

    this.checkUserStatusCount = 0;

    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    const { sandbox, vendor } = this.props;
    this.trackProPageViewed();

    if(sandbox) {
      Paddle.Environment.set('sandbox');
      // to simulate checkout completed in tests
      window.handleCheckoutCompleted = (data) => this.handleCheckoutCompleted(data);
    }

    Paddle.Setup({
      eventCallback: (data) => {
        // Checkout opens are ~10x more frequent than completions, so this is
        // the leading indicator for plan-mix experiments - it reads in weeks
        // rather than months.
        if(data.event === "Checkout.Loaded") {
          this.trackCheckoutOpened(data);
        }
        if(data.event === "Checkout.Close") {
          if(data.eventData.checkout.completed) {
            this.handleCheckoutCompleted(data);
          }
        }
      },
      vendor: parseInt(vendor)
    });

    this.setPrices();
  }

  setPrices() {
    const { couponCode, fullPriceProductIds, monthlyCouponCode } = this.props;

    const productIds = $(".price").map(function() {
      return $(this).find("[data-product]").data("product");
    }).toArray();

    if(!monthlyCouponCode) {
      this.fetchPrices(productIds, couponCode);
      return;
    }

    this.fetchPrices(productIds.filter((id) => !isFullPriceProduct(id, fullPriceProductIds)), couponCode);
    this.fetchPrices(productIds.filter((id) => isFullPriceProduct(id, fullPriceProductIds)), monthlyCouponCode);
  }

  fetchPrices(productIds, couponCode) {
    const {
      bigYearlyPriceFont,
      discountPct,
      fullPriceProductIds,
      monthlyCouponCode,
      sandbox
    } = this.props;

    $.ajax({
      dataType: "jsonp",
      data: {
        calculate_recurring_discounts: true,
        product_ids: productIds.join(","),
        coupons: couponCode
      },
      timeout: 3000,
      url: `https://${sandbox ? "sandbox-" : ""}checkout.paddle.com/api/2.0/prices`
    })
      .done((data) => {
        if(!data.success) {
          this.fallbackSetPrices(couponCode);
          return false;
        }

        try {
          data.response.products.forEach((r) => {
            const $price = $(`[data-product="${r.product_id}"]`).parents(".price");
            const listPrice = r.subscription ? r.subscription.list_price.gross : r.list_price.gross;
            const prettifyPrice = (price) => (
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: r.currency
              }).format(price)
            );
            const prettyListPrice = prettifyPrice(listPrice);

            $price.find(".default .dollars").text(prettyListPrice);

            if(r.subscription && r.subscription.trial_days) {
              $price.siblings(".period").after(`<strong>${r.subscription.trial_days} day free trial</strong>`);

              if(r.subscription.interval === "year") {
                $price.siblings(".period").after(`<div class="per-month" style="color: #aaa">${prettifyPrice(listPrice / 12)}/month</strong>`);
                $price.siblings(".guarantee").hide();
              }
            }

            // Only subscriptions go on sale; lifetime (a one-off product) is always full price.
            const isPricedWithMonthlyCoupon = !!monthlyCouponCode && couponCode === monthlyCouponCode;
            const isOffSale = !r.subscription || (isFullPriceProduct(r.product_id, fullPriceProductIds) && !isPricedWithMonthlyCoupon);
            const discountedPrice = isOffSale ? null : discountedSalePrice(r, { couponCode, discountPct });
            if(discountedPrice !== null) {
              const prettyDiscountedPrice = prettifyPrice(discountedPrice);
              $price.find(".default .dollars").css({
                "font-size": "2em",
                "text-decoration": "line-through"
              });
              $price.append(`
                <div class="discounted-price" style="color: #5cb85c; font-size: 3em; font-weight: bold">
                  ${prettyDiscountedPrice}
                </div>
              `);
              if(r.subscription && r.subscription.interval === "year") {
                $price.siblings(".per-month").text(`${prettifyPrice(discountedPrice / 12)}/month`);
                if(bigYearlyPriceFont) {
                  $price.find(".discounted-price").css({ fontSize: "4em" });
                }
              }
            }
            this.renderPerWeek($price, r, discountedPrice === null ? listPrice : discountedPrice);
          });

          // Must run after the per-product pass above, which writes the plain
          // yearly total into .dollars and would otherwise clobber this.
          if(this.props.pricingComparison) {
            this.renderYearlyComparison(data.response.products);
          }
        } catch(e) {
          this.fallbackSetPrices(couponCode);
        }
      })
      .fail(() => {
        this.fallbackSetPrices(couponCode);
      });
  }

  // With a coupon only Paddle knows which products it discounts, so no estimate is shown.
  fallbackSetPrices(couponCode) {
    const { bigYearlyPriceFont, discountPct, fullPriceProductIds } = this.props;

    $(".price").each(function() {
      const $price = $(this);
      const product = $price.find("[data-product]").data("product");

      Paddle.Product.Prices(product, function(data) {
        console.log(data);
        const grossPrice = data.recurring ? data.recurring.price.gross : data.price.gross;
        $price.find(".default .dollars").text(grossPrice);
        const yearly = data.recurring && data.recurring.subscription && data.recurring.subscription.type === "year";

        if(data.recurring && data.recurring.subscription && data.recurring.subscription.trial_days) {
          $price.siblings(".period").after(`<strong>${data.recurring.subscription.trial_days} day free trial</strong>`);

          if(yearly) {
            $price.siblings(".guarantee").hide();
          }
        }

        // TODO! https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
        if(data.recurring && !couponCode && discountPct && !isFullPriceProduct(product, fullPriceProductIds) && !grossPrice.match(/,/)) {
          const m = grossPrice.match(/(\D+)(\d.+)/);
          const discounted = m[1] + parseFloat(m[2] * (1 - discountPct)).toFixed(2);
          $price.find(".default .dollars").css({
            "font-size": "2em",
            "text-decoration": "line-through"
          });
          $price.append(`
            <div class="discounted-price" style="color: #5cb85c; font-size: ${yearly && bigYearlyPriceFont ? "4em" : "3em"}; font-weight: bold">${discounted}</div>
          `);
        }
      });
    });
  }

  renderPerWeek($price, product, price) {
    const $perWeek = $price.siblings(".js-per-week");
    if(!$perWeek.length || !product.subscription || product.subscription.frequency !== 1) { return; }

    const formatter = new Intl.NumberFormat("en-US", { currency: product.currency, style: "currency" });
    const perWeek = perWeekAmount(price, product.subscription.interval, formatter.resolvedOptions().maximumFractionDigits);
    if(perWeek) {
      $perWeek.text(`${formatter.format(perWeek)}/week`).show();
    }
  }

  planForProductId(productId) {
    const { planProductIds } = this.props;
    if(!planProductIds || productId === undefined || productId === null) { return null; }

    const match = Object.keys(planProductIds).find(
      (plan) => String(planProductIds[plan]) === String(productId)
    );

    return match || null;
  }

  pricingVariant() {
    return this.props.pricingComparison ? "comparison" : "control";
  }

  proPageRedesignProperties() {
    const { proPageRedesignVariant } = this.props;

    return proPageRedesignVariant ? { pro_page_redesign_variant: proPageRedesignVariant } : {};
  }

  // Only on /pro for users in the pro_page_redesign experiment.
  trackProPageViewed() {
    const { proPageRedesignVariant } = this.props;
    if(!proPageRedesignVariant) { return; }

    try {
      setAmplitudeUserProperties({ experiment_pro_page_redesign: proPageRedesignVariant });
      trackAmplitudeEvent("web_app_pro_page_viewed", this.proPageRedesignProperties());
    }
    catch(e) {
      // never let tracking block the checkout
    }
  }

  trackCheckoutOpened(data) {
    try {
      const productId = data && data.eventData && data.eventData.product && data.eventData.product.id;

      trackAmplitudeEvent("web_app_pro_checkout_opened", {
        plan: this.planForProductId(productId),
        pricing_variant: this.pricingVariant(),
        product_id: productId,
        ...this.proPageRedesignProperties()
      });
    }
    catch(e) {
      // never let tracking block the checkout
    }
  }

  // Re-frames the yearly plan as a per-month figure so it can be compared with
  // the monthly plan on the same unit, with the amount actually charged kept
  // explicit directly beneath it.
  renderYearlyComparison(products) {
    // Own error handling on purpose: this runs inside setPrices' try/catch,
    // and without this a bug in here would trip the catch and silently drop
    // the whole page onto the fallback price path.
    try {
      this.renderYearlyComparisonUnsafe(products);
    }
    catch(e) {
      if(this.props.sandbox) {
        console.error("renderYearlyComparison failed", e);
      }
    }
  }

  renderYearlyComparisonUnsafe(products) {
    const { discountPct, planProductIds, sandbox } = this.props;
    const hasCoupon = (product) => !!(product && product.applied_coupon && product.applied_coupon.discount);
    const warn = (...args) => { if(sandbox) { console.warn("yearly comparison:", ...args); } };

    // Match on the product ids the app is configured with rather than on
    // Paddle's interval string - those ids are the same source of truth the
    // checkout buttons and the server use.
    const findProduct = (productId) => (
      productId ? products.find((p) => String(p.product_id) === String(productId)) : null
    );
    const yearly = findProduct(planProductIds && planProductIds.yearly);
    const monthly = findProduct(planProductIds && planProductIds.monthly);

    if(!yearly || !yearly.subscription) {
      warn("no yearly subscription product in the price response", planProductIds, products);
      return;
    }

    // Dividing by 12 is only meaningful for a plan that bills once a year.
    if(yearly.subscription.interval !== "year" || yearly.subscription.frequency !== 1) {
      warn("yearly plan does not bill annually", yearly.subscription);
      return;
    }

    const yearlyTotal = yearly.subscription.list_price.gross;
    if(!(yearlyTotal > 0)) {
      warn("unusable yearly price", yearlyTotal);
      return;
    }

    // A sale, coupon or free trial has already rewritten this panel in ways the
    // comparison would contradict. The discount pass strikes through .dollars
    // and appends a full-YEAR discounted price; the trial pass adds its own
    // per-month line. Overwriting .dollars with a per-month figure on top of
    // that leaves a struck-through per-month price beside a full-year green
    // one, and a "billed annually as" note quoting the pre-discount amount the
    // customer is not charged. Skip rather than show a misleading price.
    if(discountPct || hasCoupon(yearly) || yearly.subscription.trial_days) {
      warn("discount, coupon or trial active - skipping the comparison");
      return;
    }

    const formatter = new Intl.NumberFormat("en-US", {
      currency: yearly.currency,
      style: "currency"
    });
    const format = (value) => formatter.format(value);
    // Zero-decimal currencies (JPY, KRW) must round to whole units, or the
    // formatter rounds our per-month figure back down and understates it.
    const decimals = formatter.resolvedOptions().maximumFractionDigits;

    // Rounding policy lives in paddlePrice so this page and the upgrade page
    // can't drift: per-month rounds up, savings round down.
    const perMonth = perMonthAmount(yearlyTotal, decimals);
    const $panel = $(".subscription-plan.yearly");

    $panel.find(".price .default .dollars").text(format(perMonth));
    $panel.find(".period").text("per month");
    $panel.find(".js-yearly-billed").text(`billed annually as ${format(yearlyTotal)}`).show();

    // The anchor and the saving multiply the monthly price by 12, so they're
    // only honest if that plan genuinely bills monthly. If it doesn't, the
    // per-month figure above still stands on its own.
    const monthlySubscription = monthly && monthly.subscription;
    if(!monthlySubscription || monthlySubscription.interval !== "month" || monthlySubscription.frequency !== 1) {
      warn("monthly plan does not bill monthly - skipping the comparison and saving", monthlySubscription);
      return;
    }

    if(monthly.currency !== yearly.currency) {
      warn("currency mismatch", monthly.currency, yearly.currency);
      return;
    }

    // Same reasoning as above: a coupon on the monthly plan makes x12 wrong.
    if(hasCoupon(monthly)) {
      warn("coupon on the monthly plan - skipping the anchor and saving");
      return;
    }

    const monthlyPrice = monthlySubscription.list_price.gross;
    if(!(monthlyPrice > 0)) {
      warn("unusable monthly price", monthlyPrice);
      return;
    }

    const annualized = annualizedAmount(monthlyPrice);
    if(annualized === null || annualized <= yearlyTotal) { return; }

    // A true like-for-like comparison, labelled as such - not a former price.
    $panel.find(".js-yearly-anchor").text(`${format(annualized)} if you paid monthly`).show();

    const pct = savingsPercentFromAmounts(monthlyPrice, yearlyTotal);
    if(pct) {
      $panel.find(".js-yearly-savings").text(`Save ${pct}%`).show();
    }
  }

  handleCheckoutCompleted(data) {
    const { sandbox } = this.props;

    if(sandbox) {
      console.log(data);
    }

    this.setState({ 
      loading: true
    }, () => this.checkUserStatus(data));
  }

  // track then redirect
  onFinishedWaiting(eventCallbackData) {
    const { tap } = window;
    const { eventData } = (eventCallbackData || {});
    const { userUuid } = this.props;

    if(!this.props.isAlreadyPro) {
      try {
        trackAmplitudeEvent('web_app_converted_to_pro', this.proPageRedesignProperties());
      }
      catch(e) {
        // do nothing, getting to the redirect is more important for ux
      }
    }

    setTimeout(() => this.redirect(), 500); // give tracking requests half a second to send
  }

  redirect() {
    window.location = "/pro-welcome";
  }

  // A subscriber upgrading to Lifetime is already Pro, so only Lifetime shows the purchase went through.
  isPurchaseProcessed(user, eventCallbackData) {
    const productId = eventCallbackData && eventCallbackData.eventData && eventCallbackData.eventData.product && eventCallbackData.eventData.product.id;

    return this.planForProductId(productId) === "lifetime" ? user.lifetimePro : user.isPro;
  }

  checkUserStatus(eventCallbackData) {
    if(this.checkUserStatusCount >= 5) {
      return this.onFinishedWaiting(eventCallbackData);
    }

    const { isProSubscriberUrl } = this.props;

    $.ajax({
      url: isProSubscriberUrl
    }) 
      .done((data) => {
        if(this.isPurchaseProcessed(data.user, eventCallbackData)) {
          return this.onFinishedWaiting(eventCallbackData);
        }
        this.checkUserStatusCount += 1;
        setTimeout(() => this.checkUserStatus(eventCallbackData), 2000);
      })
      .fail(() => {
        this.onFinishedWaiting(eventCallbackData);
      });
  }

  render() {
    const { loading } = this.state;

    if(loading) {
      return <LoadingOverlay className="heavy" />;
    }

    return null;
  }
}
